import React, { useState } from 'react'
import { Select, Row } from 'antd'
import Configuration from '../domain/Configuration'

const options = ['SG', 'ID', 'MY', 'HK']

const RegionSelect: React.FC<{ collapsed: boolean }> = ({ collapsed }) => {
    const [region, setRegion] = useState(localStorage.getItem('region') || 'SG')
    const handleChange = (value: string) => {
        localStorage.setItem('region', value)
        setRegion(value)
    }
    return (
        <Row
            align="middle"
            style={{
                margin: '16px 8px',
                gap: '0.5rem',
                display: Configuration.EDIT_COUNTRY() ? undefined : 'none',
                flexDirection: collapsed ? 'column' : 'row',
                flexWrap: 'nowrap',
            }}
        >
            <span>Country: </span>
            <Select value={region} style={{ width: '100%' }} onChange={handleChange}>
                {options.map((each) => (
                    <Select.Option value={each} key={each}>
                        {each}
                    </Select.Option>
                ))}
            </Select>
        </Row>
    )
}

export default RegionSelect
